import { ReactNode, useReducer } from 'react';
import { getReferralFromLocalStorage } from '../../helpers';
import ReferralContext from './referralContext';
import referralReducer from './referralReducer';
import { ReferralStateType } from './refferalTypes';

type ReferralStateProps = {
    children: ReactNode;
};

const initialState: ReferralStateType = {
    referral: getReferralFromLocalStorage(),
};

const ReferralState: React.FC<ReferralStateProps> = ({ children }) => {
    const [state, dispatch] = useReducer(referralReducer, initialState);

    return (
        <ReferralContext.Provider value={{ ...state, dispatch }}>
            {children}
        </ReferralContext.Provider>
    );
};

export default ReferralState;
